import React from 'react'

const Reports = () => {
  return (
    <>
      <div className="bg-[#e6f7ff] sm:py-10 flex justify-center">
        <div className="sm:flex flex-col sm:justify-between items-center w-full">
          <div className=" text-center py-5">
            <p
              className="mb-0 text-5xl font-bold"
              style={{
                backgroundImage:
                  "linear-gradient(120deg, #0077b3 0%, #00aacc 100%)",
                WebkitBackgroundClip: "text",
                backgroundClip: "text",
                color: "transparent",
              }}
            >
              Reports
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 px-5 py-5 max-w-7xl">
            <div className="flex items-center justify-center text-center bg-[#ffffff] px-5 py-5 border rounded-[10px] shadow-lg border-[#0077b3] duration-200 hover:scale-105 hover:shadow-2xl">
              <p className="mb-0 text-black font-semibold text-xl">
                MIS Reports with Multiple Analysis
              </p>
            </div>
            <div className="flex items-center justify-center text-center bg-[#ffffff] px-5 py-5 border rounded-[10px] shadow-lg border-[#0077b3] duration-200 hover:scale-105 hover:shadow-2xl">
              <p className="mb-0 text-black font-semibold text-xl">
                Customized Reports
              </p>
            </div>
            <div className="flex items-center justify-center text-center bg-[#ffffff] px-5 py-5 border rounded-[10px] shadow-lg border-[#0077b3] duration-200 hover:scale-105 hover:shadow-2xl">
              <p className="mb-0 text-black font-semibold text-xl">
                Reports output On screen & Printer
              </p>
            </div>
            <div className="flex items-center justify-center text-center bg-[#ffffff] px-5 py-5 border rounded-[10px] shadow-lg border-[#0077b3] duration-200 hover:scale-105 hover:shadow-2xl">
              <p className="mb-0 text-black font-semibold text-xl">
                Report export facility to <br />
                PDF, HTML, Word, Excel, etc.
              </p>
            </div>

            <div className="flex items-center justify-center text-center bg-[#ffffff] px-5 py-5 border rounded-[10px] shadow-lg border-[#0077b3] duration-200 hover:scale-105 hover:shadow-2xl">
              <p className="mb-0 text-black font-semibold text-xl">
                Multi angle Accounting & <br /> inventory reports
              </p>
            </div>
            <div className="flex items-center justify-center text-center bg-[#ffffff] px-5 py-5 border rounded-[10px] shadow-lg border-[#0077b3] duration-200 hover:scale-105 hover:shadow-2xl">
              <p className="mb-0 text-black font-semibold text-xl">
                Search / Sort / Filter option in <br />
                data entries & reports
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Reports;